import { DeliveryMode } from "api/resources/learningItems/types"
import { getPlatformURL } from "utils/helpers"

export const getAgreementURL = ({
  type,
  deliveryMode,
}: {
  type: "pgctl" | "privacy-policy" | "terms-of-use"
  deliveryMode?: DeliveryMode | null
}) => {
  if (type === "privacy-policy") {
    return getPlatformURL("suraasa", "/privacy-policy")
  }

  if (type === "terms-of-use") {
    return getPlatformURL("suraasa", "/terms-of-use")
  }
  if (type === "pgctl") {
    switch (deliveryMode) {
      case DeliveryMode.STARTER:
        return getPlatformURL("suraasa", "/enrollment-agreement/pgctl-starter")
      case DeliveryMode.PROFESSIONAL:
        return getPlatformURL(
          "suraasa",
          "/enrollment-agreement/pgctl-professional"
        )
      case DeliveryMode.EXECUTIVE:
        return getPlatformURL(
          "suraasa",
          "/enrollment-agreement/pgctl-executive"
        )
      case DeliveryMode.TDC:
        return getPlatformURL(
          "suraasa",
          "/enrollment-agreement/pgctl-executive-tdc"
        )
    }
  }

  throw new Error(`Invalid program: ${type} - ${deliveryMode}`)
}

export const getPgCTLProgramName = (deliveryMode: DeliveryMode) => {
  switch (deliveryMode) {
    case DeliveryMode.EXECUTIVE:
      return { shortName: "PgCTL Executive", modeDisplay: "Executive" }
    case DeliveryMode.TDC:
      return {
        shortName: "PgCTL Executive (TDC)",
        modeDisplay: "Executive (TDC)",
      }
    case DeliveryMode.PROFESSIONAL:
      return { shortName: "PgCTL Professional", modeDisplay: "Professional" }
    case DeliveryMode.STARTER:
      return { shortName: "PgCTL Starter", modeDisplay: "Starter" }
    case DeliveryMode.LIVE_INSTRUCTOR_LED:
      return {
        shortName: "PgCTL",
        modeDisplay: "Live Instructor Led",
      }
    case DeliveryMode.SELF_PACED:
      return { shortName: "PgCTL", modeDisplay: "Self Paced" }
  }
}

/**
 * Product slug sent to the backend when the learner signs the agreement.
 * Mirrors the slugs used in `getAgreementURL`.
 */
export const getPgCTLProductSlug = (deliveryMode: DeliveryMode) => {
  switch (deliveryMode) {
    case DeliveryMode.STARTER:
      return "pgctl-starter"
    case DeliveryMode.PROFESSIONAL:
      return "pgctl-professional"
    case DeliveryMode.EXECUTIVE:
      return "pgctl-executive"
    case DeliveryMode.TDC:
      return "pgctl-executive-tdc"
    default:
      return null
  }
}

const SIGNATURE_MIN_LENGTH = 2

/**
 * Single source of truth for what counts as a signed name. Used by the field
 * level react-hook-form rule and by the step gate, so they can never drift.
 *
 * @returns the message to show, or `null` when the name is acceptable
 */
export const getSignatureError = (value: unknown): string | null => {
  const name = typeof value === "string" ? value.trim() : ""

  if (!name) return "Required"
  if (name.length < SIGNATURE_MIN_LENGTH) return "Please enter your full name"
  return null
}
